/** Platinum-on-obsidian tokens for premium onboarding (scoped to onboarding flow). */

export const onboardingTheme = {
  bg: '#07090D',
  text: '#F4F6F8',
  textMuted: '#8B95A8',
  textPlatinum: '#9AA8B8',
  icon: '#C5CED9',
  border: 'rgba(255,255,255,0.08)',
  borderHover: 'rgba(255,255,255,0.16)',
  borderSelected: 'rgba(255,255,255,0.28)',
  surface: 'rgba(255,255,255,0.04)',
  surfaceHover: 'rgba(255,255,255,0.07)',
  platinumFrom: '#E8EDF4',
  platinumTo: '#9AA8B8',
} as const;

export const onboardingEase = [0.16, 1, 0.3, 1] as const;

export const onboardingMotion = {
  duration: 0.5,
  ease: onboardingEase,
  stagger: 0.05,
} as const;

export const onboardingClasses = {
  root: 'onboarding-premium font-display text-[#F4F6F8]',
  heading: 'text-4xl md:text-5xl font-medium tracking-[-0.02em] leading-tight text-[#F4F6F8]',
  subtitle: 'text-lg md:text-xl font-normal text-[#8B95A8] mt-4 mb-8 leading-relaxed',
  microLabel: 'text-[11px] uppercase tracking-[0.2em] text-[#8B95A8] font-medium',
  sidebarDivider:
    'h-px w-full bg-gradient-to-r from-transparent via-white/[0.14] to-transparent',
  textInput:
    'w-full text-2xl md:text-4xl bg-transparent border-b-2 py-4 outline-none placeholder:text-white/15 font-medium transition-all duration-300 border-white/10 focus:border-[#C5CED9] focus:shadow-[0_1px_0_0_rgba(197,206,217,0.4)]',
  textInputError: 'border-red-400/80 focus:border-red-400 focus:shadow-none',
  primaryBtn:
    'px-8 py-3.5 bg-white text-[#0A0A0B] rounded-full font-medium text-base hover:bg-[#E8EDF4] transition-all duration-300 flex items-center gap-2 hover:scale-[1.02] active:scale-[0.98]',
  glassCard:
    'rounded-[28px] border border-white/[0.08] bg-white/[0.04] backdrop-blur-xl transition-all duration-500',
  glassCardSelected:
    'border-white/[0.28] bg-white/[0.07] shadow-[0_0_0_1px_rgba(255,255,255,0.12),0_16px_48px_rgba(0,0,0,0.35)]',
  glassCardHover: 'hover:border-white/[0.16] hover:bg-white/[0.06] hover:-translate-y-0.5',
  iconRing:
    'h-14 w-14 rounded-2xl border border-white/10 bg-white/[0.06] backdrop-blur-md flex items-center justify-center',
  iconRingSelected:
    'border-white/25 shadow-[0_0_0_1px_rgba(255,255,255,0.35),0_8px_32px_rgba(255,255,255,0.06)]',
  navBtn:
    'w-11 h-11 rounded-full bg-white/[0.06] border border-white/10 hover:bg-white/[0.1] hover:border-white/20 flex items-center justify-center disabled:opacity-25 transition-all duration-300',
  selectRow:
    'group flex items-center gap-4 p-5 md:py-5 md:px-6 rounded-[20px] border cursor-pointer transition-all duration-500',
  selectRowDefault:
    'border-white/[0.08] bg-white/[0.04] hover:border-white/[0.16] hover:bg-white/[0.06]',
  selectRowSelected:
    'border-white/[0.28] bg-white/[0.07] shadow-[0_0_0_1px_rgba(255,255,255,0.1)]',
} as const;
